/**
 * Formats a number to display with K, M, B notation for large numbers
 * @param num - The number to format (can be string or number)
 * @returns Formatted string (e.g., "1.2K", "3.5M", "1B")
 */
export const formatNumber = (num: string | number): string => {
  const numValue = typeof num === "string" ? parseInt(num, 10) : num

  if (isNaN(numValue)) return "0"

  if (numValue < 1000) {
    return numValue.toString()
  }

  if (numValue < 1000000) {
    const formatted = (numValue / 1000).toFixed(1)
    return formatted.endsWith(".0")
      ? `${Math.floor(numValue / 1000)}K`
      : `${formatted}K`
  }

  if (numValue < 1000000000) {
    const formatted = (numValue / 1000000).toFixed(1)
    return formatted.endsWith(".0")
      ? `${Math.floor(numValue / 1000000)}M`
      : `${formatted}M`
  }

  const formatted = (numValue / 1000000000).toFixed(1)
  return formatted.endsWith(".0")
    ? `${Math.floor(numValue / 1000000000)}B`
    : `${formatted}B`
}
